import React from "react";
import GenericPullConfigListing from "../GenericPullConfigListing";
import CheckmarxSCAMappingForm from "./CheckmarxSCAMappingForm";
import CheckmarxSCACredentialForm from "./CheckmarxSCACredentialForm";

export default function CheckmarxSCAConfigListing(props){
    return (
        <GenericPullConfigListing 
            {...props}
            toolName={props.name}
            MappingForm={CheckmarxSCAMappingForm}
            CredentialsForm={CheckmarxSCACredentialForm}
            componentName="Project Name"
            componentKey="projectName"

        />
    )
}